module.exports = __webpack_public_path__ + "static/media/qnica.a8a48c01.png";